import { render, staticRenderFns } from "./GymPageHeader.vue?vue&type=template&id=209cc537"
import script from "./GymPageHeader.vue?vue&type=script&lang=js"
export * from "./GymPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports